import {createAsyncThunk} from '@reduxjs/toolkit'

import {API} from '../../utils/API'

export const createUser = createAsyncThunk('/users/create', async(user)=>{
const {data} = await API.post(`/user/signup`, user)
return data
})

export const validateUser = createAsyncThunk('/users/validate',async(user)=>{
const {data} = await API.post(`/user/signin`, user)
return data
})